import React from 'react';
import propTypes from 'prop-types';

//import components
import Error404Page from '../components/Error404Page.js';

const Error404 = ({location}) => {
    return (
        <section className="error">
            <Error404Page location={location}/>
        </section>
    );
};

Error404.propTypes = {
    location: propTypes.shape({pathname: propTypes.string.isRequired}),
};

export default Error404;



// WEBPACK FOOTER //
// ./src/containers/Error-404.js